import SRPFLoginPage from './SRPFLoginPage';

const LoginDemo = () => {
  return <SRPFLoginPage />;
};

export default LoginDemo;
